import React from 'react';

const defaultContext = {
  whitelistedStores: [],
  blacklistedItems: [],
  rentalEstimateEnabled: false,
  contractTermsEnabled: false,
  damageProtectionEnabled: false,
  FDAv4Enabled: false
};

const FeatureSwitchContext = React.createContext(defaultContext);

export {
  defaultContext,
  FeatureSwitchContext
};
